
// export const fetchIsLogged = (state) => state?.user.isLogged;
export const fetchIsLogged = (state) => state.sdkClient.instance?.isLogged;
